var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-range-facet" },
    [
      _c(
        "div",
        {
          staticClass: "rb-range-facet__prices",
          attrs: {
            "data-mnt-filter-price":
              "" +
              _vm.currencySymbol +
              _vm.minRange +
              " - " +
              _vm.currencySymbol +
              _vm.maxRange,
          },
        },
        [
          _c("div", { staticClass: "rb-range-facet__price" }, [
            _c("span", { staticClass: "rb-range-facet__currency" }, [
              _vm._v("\n        " + _vm._s(_vm.currencySymbol) + "\n      "),
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "rb-range-facet__input",
              attrs: {
                type: _vm.typeInput,
                inputmode: "numeric",
                pattern: "\\d*",
              },
              domProps: { value: _vm.selectedMin },
              on: {
                keyup: function (e) {
                  return _vm.debounceValueInput(
                    { minValue: e.target.value, maxValue: _vm.selectedMax },
                    _vm.ALGOLIA_FACETS.MIN
                  )
                },
                keydown: _vm.keyDown,
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "rb-range-facet__price",
              class: { "--reverse-format": _vm.formatPrice },
            },
            [
              _c("input", {
                staticClass: "rb-range-facet__input",
                attrs: {
                  type: _vm.typeInput,
                  inputmode: "numeric",
                  pattern: "\\d*",
                },
                domProps: { value: _vm.selectedMax },
                on: {
                  keyup: function (e) {
                    return _vm.debounceValueInput(
                      { minValue: _vm.selectedMin, maxValue: e.target.value },
                      _vm.ALGOLIA_FACETS.MAX
                    )
                  },
                  keydown: _vm.keyDown,
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "rb-range-facet__currency" }, [
                _vm._v("\n        " + _vm._s(_vm.currencySymbol) + "\n      "),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("MultiRangeSlider", {
        attrs: {
          min: +_vm.minRange,
          max: +_vm.maxRange,
          "min-value": +_vm.selectedMin,
          "max-value": +_vm.selectedMax,
          step: _vm.getStep,
          ruler: false,
          label: false,
          "range-margin": _vm.getMinimumDistance,
        },
        on: { input: _vm.changeValueSlider },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }